import Service from '../Service'

class PageBuilderService extends Service {

  get build () {

  	return [
  	  {
  	  	id: 1,
  	  	slug: 'main-economic-indicator',
        fetchName: 'mainEconomicIndicator',
  	  	categories: [
          {
            id: 1,
            name: 'population',
            slug: 'population',
            identifer: 'population',
            data: {
              select: ['country_id', 'year', 'population', 'group_id'],
              model: {
                country_id: [],
                year: []
              }
            },
            filter: [
              {
                label: 'country',
                filterType: 2,
                keyName: 'countries',
                additional: 'country_id',
                dependToData: {
                  key: 'country_id',
                  value: 'country_name'
                },
                data: []
              },
              {
                label: 'year',
                filterType: 1,
                keyName: 'year',
                additional: false
              }
            ],
            table: {
              columns: [
                {
                  name: 'country',
                  column: 'country_name',
                  position: 'left'
                },
                {
                  name: 'year',
                  column: 'year'
                },
                {
                  name: 'population',
                  column: 'population',
                  position: 'right'
                }
              ]
            },
            worldMap: {
              filters: [
                {
                  key: 'iso',
                  prop: 'id'
                },
                {
                  key: 'population',
                  prop: 'value'
                },
                {
                  key: 'group_name',
                  prop: 'group_name'
                }
              ]
            },
            dynamicPages: [{ divName: 'world-map', pageName: 'WorldMap' }, { title_ka: 'მოსახლეობა ქვეყნებისა და რეგიონების მიხედვით, %', title_en: 'Population by Countries and Regions, %', divName: 'hight-chart', pageName: 'Highchart' }],
            source: 'worldBank',
            sourceLink: 'https://data.worldbank.org/indicator/SP.POP.TOTL?view=chart'
          },
  	      {
            id: 2,
            name: 'gdp',
            slug: 'gdp',
            identifer: 'gdp',
            data: {
              select: ['country_id', 'year', 'gdp', 'group_id'],
              model: {
                country_id: [],
                year: []
              }
            },
            filter: [
              {
                label: 'country',
                filterType: 2,
                keyName: 'countries',
                additional: 'country_id',
                dependToData: {
                  key: 'country_id',
                  value: 'country_name'
                },
                data: []
              },
              {
                label: 'year',
                filterType: 1,
                keyName: 'year',
                additional: false
              }
            ],
            table: {
              columns: [
                {
                  name: 'country',
                  column: 'country_name',
                  position: 'left'
                },
                {
                  name: 'year',
                  column: 'year'
                },
                {
                  name: 'gdp',
                  column: 'gdp',
                  position: 'right'
                }
              ]
            },
            worldMap: {
              filters: [
                {
                  key: 'iso',
                  prop: 'id'
                },
                {
                  key: 'gdp',
                  prop: 'value'
                },
                {
                  key: 'group_name',
                  prop: 'group_name'
                }
              ]
            },
            dynamicPages: [{ divName: 'world-map', pageName: 'WorldMap' }, { title_ka: 'მშპ ქვეყნებისა და რეგიონების მიხედვით, %', title_en: 'GDP by Countries and Regions, %', divName: 'hight-chart', pageName: 'Highchart' }],
            source: 'internationalMonetaryFund',
            sourceLink: 'https://www.imf.org/external/datamapper/NGDPD@WEO/OEMDC/ADVEC/WEOWORLD'
          },
  	      {
            id: 3,
            name: 'gdpPerCapita',
            slug: 'gdp-per-capita',
            identifer: 'gdp_per_capita',
            data: {
              select: ['country_id', 'year', 'gdp_per_capita', 'group_id'],
              model: {
                country_id: [],
                year: []
              }
            },
            filter: [
              {
                label: 'country',
                filterType: 2,
                keyName: 'countries',
                additional: 'country_id',
                dependToData: {
                  key: 'country_id',
                  value: 'country_name'
                },
                data: []
              },
              {
                label: 'year',
                filterType: 1,
                keyName: 'year',
                additional: false
              }
            ],
            table: {
              columns: [
                {
                  name: 'country',
                  column: 'country_name',
                  position: 'left'
                },
                {
                  name: 'year',
                  column: 'year'
                },
                {
                  name: 'gdp_per_capita',
                  column: 'gdp_per_capita',
                  position: 'right'
                }
              ]
            },
            worldMap: {
              filters: [
                {
                  key: 'iso',
                  prop: 'id'
                },
                {
                  key: 'gdp_per_capita',
                  prop: 'value'
                },
                {
                  key: 'group_name',
                  prop: 'group_name'
                }
              ]
            },
            dynamicPages: [{ divName: 'world-map', pageName: 'WorldMap' }, { title_ka: 'მშპ ერთ სულზე, აშშ დოლარი (ტოპ 10 ქვეყანა)', title_en: 'GDP per capita, US $ (Top 10 Countries)', axis_ka: 'აშშ დოლარი', axis_en: 'US $', divName: 'bar-chart', pageName: 'BarChart' }],
            source: 'internationalMonetaryFund',
            sourceLink: 'https://www.imf.org/external/datamapper/NGDPDPC@WEO/OEMDC/ADVEC/WEOWORLD'
          },
  	      {
            id: 4,
            name: 'unemploymentRate',
            slug: 'unemployment-rate',
            identifer: 'gdp_per_capita_ppp',
            data: {
              select: ['country_id', 'year', 'gdp_per_capita_ppp', 'group_id'],
              model: {
                country_id: [],
                year: []
              }
            },
            filter: [
              {
                label: 'country',
                filterType: 2,
                keyName: 'countries',
                additional: 'country_id',
                dependToData: {
                  key: 'country_id',
                  value: 'country_name'
                },
                data: []
              },
              {
                label: 'year',
                filterType: 1,
                keyName: 'year',
                additional: false
              }
            ],
            table: {
              columns: [
                {
                  name: 'country',
                  column: 'country_name',
                  position: 'left'
                },
                {
                  name: 'year',
                  column: 'year'
                },
                {
                  name: 'unemployment_rate',
                  column: 'gdp_per_capita_ppp',
                  position: 'right'
                }
              ]
            },
            worldMap: {
              filters: [
                {
                  key: 'iso',
                  prop: 'id'
                },
                {
                  key: 'gdp_per_capita_ppp',
                  prop: 'value'
                }
              ]
            },
            dynamicPages: [{ divName: 'world-map', pageName: 'WorldMap' }, { title_ka: 'მშპ ერთ სულზე პპპ, საერთაშორისო დოლარი (ტოპ 10 ქვეყანა)', title_en: 'GDP per capita PPP, International $ (Top 10 Countries)', axis_ka: 'საერთაშორისო დოლარი', axis_en: 'International $', divName: 'bar-chart', pageName: 'BarChart' }],
            source: 'worldBank',
            sourceLink: 'https://data.worldbank.org/indicator/NY.GDP.PCAP.PP.CD?view=chart'
          },
  	      {
            id: 5,
            name: 'inflation',
            slug: 'inflation',
            identifer: 'inflation',
            data: {
              select: ['country_id', 'year', 'inflation', 'group_id'],
              model: {
                country_id: [],
                year: []
              }
            },
            filter: [
              {
                label: 'country',
                filterType: 2,
                keyName: 'countries',
                additional: 'country_id',
                dependToData: {
                  key: 'country_id',
                  value: 'country_name'
                },
                data: []
              },
              {
                label: 'year',
                filterType: 1,
                keyName: 'year',
                additional: false
              }
            ],
            table: {
              columns: [
                {
                  name: 'country',
                  column: 'country_name',
                  position: 'left'
                },
                {
                  name: 'year',
                  column: 'year'
                },
                {
                  name: 'inflation',
                  column: 'inflation',
                  position: 'right'
                }
              ]
            },
            worldMap: {
              filters: [
                {
                  key: 'iso',
                  prop: 'id'
                },
                {
                  key: 'inflation',
                  prop: 'value'
                }
              ]
            },
            dynamicPages: [{ divName: 'world-map', pageName: 'WorldMap' }],
            source: 'internationalMonetaryFund',
            sourceLink: 'https://www.imf.org/external/datamapper/PCPIPCH@WEO/OEMDC/ADVEC/WEOWORLD'
          }
  	  	]
  	  },
      {
        id: 2,
        slug: 'international-ratings',
        fetchName: 'internationalRatings',
        categories: [
          {
            id: 1,
            name: 'easeOfDoingBussiness',
            slug: 'ease-of-doing-bussiness',
            aditionalFilter: {
              model: {
                type: 'global_rank_ease_of_doing_bussiness'
              },
              list: [
                'global_rank_ease_of_doing_bussiness',
                'starting_a_business',
                'registering_property',
                'paying_taxes'
              ]
            },
            data: {
              select: [
                'country_id',
                'global_rank_ease_of_doing_bussiness',
                'starting_a_business',
                'registering_property',
                'paying_taxes',
                'db_score'
              ],
              model: {
                country_id: [],
                group_id: []
              }
            },
            filter: [
              {
                label: 'country',
                filterType: 2,
                keyName: 'countries',
                additional: 'country_id',
                dependToData: {
                  key: 'country_id',
                  value: 'country_name'
                },
                data: []
              },
              {
                label: 'country_group',
                filterType: 2,
                keyName: 'country_group',
                additional: 'group_id'
              }
            ],
            table: {
              columns: [
                {
                  name: 'country',
                  column: 'country_name',
                  position: 'left'
                },
                {
                  name: 'global_rank_ease_of_doing_bussiness',
                  column: 'global_rank_ease_of_doing_bussiness',
                  position: 'right'
                },
                {
                  name: 'starting_a_business',
                  column: 'starting_a_business',
                  position: 'right'
                },
                {
                  name: 'registering_property',
                  column: 'registering_property',
                  position: 'right'
                },
                {
                  name: 'paying_taxes',
                  column: 'paying_taxes',
                  position: 'right'
                },
                {
                  name: 'db_score',
                  column: 'db_score',
                  position: 'right'
                }
              ]
            },
            worldMap: {
              filters: [
                {
                  key: 'iso',
                  prop: 'id'
                },
                {
                  key: '',
                  prop: 'value'
                }
              ]
            },
            source: 'worldBankWithYear',
            sourceLink: 'https://www.doingbusiness.org/en/rankings',
            dynamicPages: [{ divName: 'starting-business', pageName: 'StartingBusiness' }]
          },
          {
            id: 2,
            name: 'globalCompetitivenessIndex',
            slug: 'global-competitiveness-index',
            identifer: 'global_competitiveness',
            data: {
              select: [
                'country_id',
                'global_competitiveness',
                'global_competitiveness_rank'
              ],
              model: {
                country_id: []
              }
            },
            filter: [
              {
                label: 'country',
                filterType: 2,
                keyName: 'countries',
                additional: 'country_id',
                dependToData: {
                  key: 'country_id',
                  value: 'country_name'
                },
                data: []
              }

              // {
              //   label: 'country',
              //   filterType: 2,
              //   keyName: 'countries',
              //   additional: 'country_id'
              // }
            ],
            table: {
              columns: [
                {
                  name: 'country',
                  column: 'country_name',
                  position: 'left'
                },
                {
                  name: 'global_competitiveness_rank',
                  column: 'global_competitiveness_rank',
                  position: 'right'
                },
                {
                  name: 'global_competitiveness',
                  column: 'global_competitiveness',
                  position: 'right'
                }
              ]
            },
            worldMap: {
              filters: [
                {
                  key: 'iso',
                  prop: 'id'
                },
                {
                  key: 'global_competitiveness',
                  prop: 'value'
                }
              ]
            },
            source: 'worldEconomicForumWithYear',
            sourceLink: 'https://www.weforum.org/reports/global-competitiveness-report-2019',
            dynamicPages: [{ divName: 'global-compettiveness', pageName: 'GlobalCompettiveness' }]
          },
          {
            id: 3,
            name: 'humanDevelopmentIndex',
            slug: 'human-development-index',
            identifer: 'hdi',
            data: {
              select: [
                'country_id',
                'hdi',
                'hdi_rank',
                'development_id'
              ],
              model: {
                country_id: []
              }
            },
            filter: [
              {
                label: 'country',
                filterType: 2,
                keyName: 'countries',
                additional: 'country_id',
                dependToData: {
                  key: 'country_id',
                  value: 'country_name'
                },
                data: []
              }
            ],
            table: {
              columns: [
                {
                  name: 'country',
                  column: 'country_name',
                  position: 'left'
                },
                {
                  name: 'hdi_rank',
                  column: 'hdi_rank',
                  position: 'right'
                },
                {
                  name: 'hdi',
                  column: 'hdi',
                  position: 'right'
                },
                {
                  name: 'development_name',
                  column: 'development_name',
                  position: 'right'
                }
              ]
            },
            worldMap: {
              filters: [
                {
                  key: 'iso',
                  prop: 'id'
                },
                {
                  key: 'hdi',
                  prop: 'value'
                }
              ]
            },
            source: 'unitedNationsWithYear',
            sourceLink: 'http://report.hdr.undp.org/',
            dynamicPages: [{ divName: 'human-development-index', pageName: 'HumanDevelopmentIndex', withoutAwait: true }]
          },
          {
            id: 4,
            name: 'fitch',
            slug: 'fitch',
            data: {
              static: true,
              list: [
                {
                  name: 'Fitch',
                  2016: 'BB-',
                  2017: 'BB-',
                  2018: 'BB-',
                  2019: 'BB',
                  2020: 'BB',
                  2021: 'BB',
                  2022: 'BB',
                  2023: 'BB',
                  2024: 'BB',
                  2025: 'BB',
                  source: 'fitchRatings',
                  link: 'https://www.fitchratings.com/'
                },
                {
                  name: "Moody's",
                  2016: 'Ba3',
                  2017: 'Ba2',
                  2018: 'Ba2',
                  2019: 'Ba2',
                  2020: 'Ba2',
                  2021: 'Ba2',
                  2022: 'Ba2',
                  2023: 'Ba2',
                  2024: 'Ba2',
                  2025: 'Ba2',
                  source: 'moodysCorporation',
                  link: 'https://www.moodys.com/'
                },
                {
                  name: 'Scope',
                  2016: '',
                  2017: '',
                  2018: 'BB',
                  2019: 'BB',
                  2020: 'BB',
                  2021: 'BB',
                  2022: 'BB',
                  2023: 'BB',
                  2024: 'BB',
                  2025: 'BB',
                  source: 'scopeRatings',
                  link: 'https://www.scoperatings.com/#search/research/detail/156829EN'
                },
                {
                  name: 'S&P',
                  2016: 'BB-',
                  2017: 'BB-',
                  2018: 'BB-',
                  2019: 'BB',
                  2020: 'BB',
                  2021: 'BB',
                  2022: 'BB',
                  2023: 'BB',
                  2024: 'BB',
                  2025: 'BB',
                  source: 'standardRatingsServices',
                  link: 'https://www.spglobal.com/ratings/en/'
                }
              ]
            },
            filter: [],
            table: {
              columns: [
                {
                  name: 'empty',
                  column: 'name',
                  position: 'left'
                },

                {
                  name: 2016,
                  column: 2016,
                  position: 'right'
                },
                {
                  name: 2017,
                  column: 2017,
                  position: 'right'
                },
                {
                  name: 2018,
                  column: 2018,
                  position: 'right'
                },
                {
                  name: 2019,
                  column: 2019,
                  position: 'right'
                },
                {
                  name: 2020,
                  column: 2020,
                  position: 'right'
                },
                {
                  name: 2021,
                  column: 2021,
                  position: 'right'
                },
                {
                  name: 2022,
                  column: 2022,
                  position: 'right'
                },
                {
                  name: 2023,
                  column: 2023,
                  position: 'right'
                },
                {
                  name: 2024,
                  column: 2024,
                  position: 'right'
                },
                {
                  name: 2025,
                  column: 2025,
                  position: 'right'
                },
                {
                  name: 'text',
                  column: 'source',
                  position: 'left'
                }
              ]
            }
          }
        ]
      }
  	]
  }

}

PageBuilderService.id = 'PageBuilderService'

export default PageBuilderService





